import * as Actions from '../Actions/EmpresaPessoaJornadaActions';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
};


const EmpresaPessoaJornadaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAPESSOAJORNADA:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAJORNADA_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    id: action.id
                };
            }
        case Actions.EMPRESAPESSOAJORNADA_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAJORNADA_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaPessoaJornadaReducer
export default reducer;
